<template>
    <div class="section_title">
        <h4 class="small_title">
            {{title}}
        </h4>
        <hr>
    </div>
</template>

<script>
export default {
    name:"SectionTitle",
    props:{
        title:{
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
hr{
    height: 1px;
    background-color: #ddd;
    border: none;
}
h4{
    text-transform: uppercase;
}
</style>